import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Modal } from 'antd'

const localizer = momentLocalizer(moment)

const CalendarTwo = ({ session_data }) => {

  const [allSession, setAllSession] = useState([])

  const [modalShow, setModalShow] = useState(false);
  const [current_session, setCurrentSession] = useState({})
  const [currentView, setCurrentView] = useState(Views.WEEK);

  useEffect(() => {
    const formattedSessions = session_data?.map((session) => {
      const [startTime, endTime] = session.bookingtime.split(" - ");
      
      const practicalHours = Number(session?.cources?.practical) || 0;
      const theoryHours = Number(session?.cources?.theory) || 0;
      const courseDurationHours = practicalHours + theoryHours;
      const dailyHours = moment(endTime, "hh:mm A").diff(moment(startTime, "hh:mm A"), "hours");
      const daysRequired = Math.ceil(courseDurationHours / dailyHours);
      
      let currentDate = moment(session.bookingdate, "YYYY-MM-DD");
      let validDaysCount = 0;
      const overallEndDate = currentDate.clone();
      
      // Calculate the overall end date for multi-day events (for Month view)
      while (validDaysCount < daysRequired) {
        if (overallEndDate.day() !== 0 && overallEndDate.day() !== 6) { // Skip weekends
          validDaysCount++;
        }
        if (validDaysCount < daysRequired) {
          overallEndDate.add(1, "days");
        }
      }
  
      const events = [];
      let eventStartDate = currentDate.clone();
      validDaysCount = 0;
      
      // Handle Month view to create multi-day events but skip weekends
      if (currentView === Views.MONTH) {
        while (validDaysCount < daysRequired) {
          if (currentDate.day() !== 0 && currentDate.day() !== 6) {
            if (eventStartDate === null) {
              eventStartDate = currentDate.clone();
            }
      
            validDaysCount++;
          }
      
          if (currentDate.day() === 5 || validDaysCount === daysRequired) {
            events.push({
              id: session.id,
              title: `Student: ${session?.user?.name}, Lesson: ${session?.cources?.title}`,
              start: moment(`${eventStartDate.format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD hh:mm A").toDate(),
              end: moment(`${currentDate.format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD hh:mm A").toDate(),
              overallstartdate : session?.bookingdate,
              overallEndDate: overallEndDate.format("YYYY-MM-DD"),
              slot: session.bookingtime,
              student_name: session?.user?.name,
              student_phone: session?.user?.mobile,
              student_email: session?.user?.email,
              session_type: session?.cources?.title,
              theory : session?.cources?.theory,
              practical : session?.cources?.practical,
              status: session.status === 0 ? "Pending" : session.status === 1 ? "In-Progress" : "Completed",
            });
            eventStartDate = null;
          }
      
          currentDate.add(1, "days");
        }
      }
      
      // For Week and Day views, create single-day events
      if (currentView === Views.WEEK || currentView === Views.DAY) {
        // Generate events for each individual day in the session
        while (validDaysCount < daysRequired) {
          if (currentDate.day() !== 0 && currentDate.day() !== 6) { // Only weekdays
            events.push({
              id: session.id,
              title: `Student: ${session?.user?.name}, Lesson: ${session?.cources?.title}`,
              start: moment(`${currentDate.format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD hh:mm A").toDate(),
              end: moment(`${currentDate.format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD hh:mm A").toDate(),
              overallstartdate: session?.bookingdate,
              overallEndDate: overallEndDate.format("YYYY-MM-DD"),
              slot: session.bookingtime,
              student_name: session?.user?.name,
              student_phone: session?.user?.mobile,
              student_email: session?.user?.email,
              session_type: session?.cources?.title,
              theory : session?.cources?.theory,
              practical : session?.cources?.practical,
              status: session.status === 0 ? "Pending" : session.status === 1 ? "In-Progress" : "Completed",
            });
            validDaysCount++; // Only increment for actual days
          }
          currentDate.add(1, "days");
        }
      }
  
      return events;
    }); 
    
    setAllSession(formattedSessions?.flat());
  }, [session_data, currentView]); 
 

  const handleShowSession = (event) => {
    setCurrentSession(event)
    setModalShow(true)
  }

  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="ps-card ps-card--sale-report">
        <div className="ps-card__content">
          {/* <Calendar /> */}
          <div className='calender-container'>
            <Calendar
              localizer={localizer}
              events={allSession}
              startAccessor="start"
              endAccessor="end"
              views={[Views.MONTH, Views.WEEK, Views.DAY,]}
              popup
              style={{ height: 550, backgroundColor: '#fff', padding: '10px', borderRadius: '10px' }}
              onSelectEvent={handleShowSession}
              draggableAccessor={() => true}
              defaultView='week'
              onView={handleViewChange}
            />
          </div>
        </div>

        <Modal
          open={modalShow}
          title="Lesson Details"
          width={600}
          centered
          onCancel={() => setModalShow(false)}
          footer={null}
        >
          <div>
            <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
              <tbody>
                <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Student Name</th>
                  <td className='p-3'>{current_session?.student_name || "--" }</td>
                </tr>
                 <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Student Contact</th>
                  <td className='p-3'>{current_session?.student_phone || "--" }</td>
                </tr>
                 <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Student Email</th>
                  <td className='p-3'>{current_session?.student_email || "--" }</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3 bg-light'>Start Date & Timing</th>
                  <td className='p-3'> {moment(current_session?.overallstartdate).format('DD MMM, YYYY')} <span className='px-3'>|</span> {current_session?.slot}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3 bg-light'>End Date</th>
                  <td className='p-3'> {moment(current_session?.overallEndDate).format('DD MMM, YYYY')}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Driving Cource</th>
                  <td className='p-3'>{current_session?.session_type}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Theory Session</th>
                  <td className='p-3'>{current_session?.theory} Hours</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Practical Session</th>
                  <td className='p-3'>{current_session?.practical} Hours</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3 bg-light-cyan'>Status</th>
                  <td className='p-3'>
                    <span className={`fw-bold text-${current_session.status === "Pending" ? 'danger' : current_session.status === "In-Progress" ? 'warning' : 'success'} `}>
                      {current_session?.status}</span> </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </Modal>

      </div>
    </>
  )
}

export default CalendarTwo